import { Box, Stack, Typography } from "@mui/material";

export interface FormSectionProps {
  /** Section heading */
  title: string;
  /** Optional helper text below the title */
  helperText?: string;
  children: React.ReactNode;
}

/**
 * Groups form fields under a title and optional helper.
 * Use for long forms (e.g. Transfer: "Route details", "Stops").
 */
export default function FormSection({ title, helperText, children }: FormSectionProps) {
  return (
    <Stack spacing={1.5} sx={{ width: "100%" }}>
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {helperText && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {helperText}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>{children}</Box>
    </Stack>
  );
}
